export const pricingRulesSection = "/pricing-rules/";

export const pricingRulesListPath = pricingRulesSection;
export const pricingRuleAddPath = `${pricingRulesSection}add/`;
export const pricingRuleCheckPath = `${pricingRulesSection}check/`;
export const pricingRuleEditPath = `${pricingRulesSection}:id/`;

export const pricingRulesListUrl = () => pricingRulesListPath;
export const pricingRuleAddUrl = () => pricingRuleAddPath;
export const pricingRuleCheckUrl = () => pricingRuleCheckPath;
export const pricingRuleEditUrl = (id: string) =>
  pricingRuleEditPath.replace(":id", encodeURIComponent(id));
